import styled from "styled-components";
import { Content as BaseContent } from "../SideBar/styled";

// Mesma estrutura e identidade do menu do usuário (SideBar/styled.js); só entra
// o que é do ambiente administrativo: o selo "Administração" sob o logo e o
// separador antes dos itens que saem do painel.
export const Content = styled(BaseContent)`
  .tag-admin{
    display: block;
    margin: -10px auto 14px;
    width: fit-content;
    padding: 2px 10px;
    border-radius: 10px;
    background: #1E1F20;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
  }

  /* Sem isto o painel nunca encolhe abaixo do conteúdo mais largo (min-width
     automático de item flex) e, em tela estreita, ultrapassa a borda direita. */
  .panel{ min-width: 0; }

  .separador{
    height: 1px;
    margin: 12px 18px;
    background: #EFF0F2;
  }

  .nav-item:focus-visible{
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }

  /* O menu do usuário usa <div> para "Sair"; aqui é <button>, então zera o
     visual padrão para ficar igual aos links. */
  button.nav-item{
    border: none;
    background: transparent;
    font-family: inherit;
    text-align: left;
  }

  .sidebar.colapsado{
    .tag-admin{ font-size: 0; padding: 2px 8px; }
    .tag-admin::before{ content: "ADM"; font-size: 9px; }
    .separador{ margin: 10px 8px; }
  }
`;
